import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { useSelector } from "react-redux";

const LoaderPage = () => {

    const staticContent = useSelector((state) => state?.staticContent
        ?.commonStaticContentSlice)

    const loaderPageMsg = staticContent?.loaderPage?.msg


    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            }}
        >
            <CircularProgress disableShrink />
            <div>{loaderPageMsg}...</div>
        </Stack>
    )
}

export default LoaderPage